import React from 'react';
import { Path, Rect, Circle, Line, Polygon, Polyline, Svg } from 'react-native-svg';
import type { IconProps } from './types';
import { Colors } from '../../../themes/colors';

export const CircleCheckIcon: React.FC<IconProps> = ({
  size = 16,
  color = Colors.role.textStrong,
  style,
    ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path
      d="M4.88571 9.14694L7.87792 12.0857L13.1143 6.94286M17.2286 9C17.2286 13.5445 13.5445 17.2286 9 17.2286C4.45549 17.2286 0.771429 13.5445 0.771429 9C0.771429 4.45549 4.45549 0.771429 9 0.771429C13.5445 0.771429 17.2286 4.45549 17.2286 9Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </Svg>
);

CircleCheckIcon.displayName = 'CircleCheckIcon';
